import OffcanvasContainer from "../../../Components/UiKits/Offcanvas/OffcanvasContainer";

const Offcanvas = () => {
  return <OffcanvasContainer />;
};

export default Offcanvas;
